<template>
  <div>
    <v-card-title class="mt-5">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      disable-pagination
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>FLASH SALES HISTORY</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="accent" @click="getFlashSalesHistory"
            ><v-icon> mdi-refresh </v-icon> Refresh</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        <tr>
          <td>
            <span class="secondary--text">{{ item.date.split("T")[0] }} </span>
          </td>
        </tr>
      </template>
      <template v-slot:[`item.url`]="{ item }">
        <tr>
          <td>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  fab
                  @click="openFile(item.url)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success">mdi-google-spreadsheet</v-icon>
                </v-btn>
              </template>
              <span>Open file</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "FlashSalesHistory",
  props: {},
  components: {},
  data: () => ({
    headers: [
      {
        text: "Date",
        align: "start",
        value: "date",
        divider: true,
        class: "footer basic--text",
        width: "8%",
      },
      {
        text: "File",
        align: "start",
        value: "url",
        divider: true,
        class: "footer basic--text",
        width: "5%",
      },
      {
        text: "Name",
        align: "start",
        value: "firstName",
        divider: true,
        class: "footer basic--text",
        width: "7%",
      },
      {
        text: "Surname",
        align: "start",
        value: "lastName",
        divider: true,
        class: "footer basic--text",
        width: "7%",
      },
      //   {
      //     text: "Categories",
      //     align: "start",
      //     value: "categories",
      //     divider: true,
      //     class: "footer basic--text",
      //   },
      {
        text: "Condition",
        align: "start",
        value: "condition",
        divider: true,
        class: "footer basic--text",
      },
      {
        text: "Brands",
        align: "start",
        value: "brands",
        divider: true,
        class: "footer basic--text",
      },
    ],
    items: [],
    search: "",
  }),
  computed: {},
  methods: {
    async getFlashSalesHistory() {
      try {
        const response = await this.$store.dispatch("getFlashSalesHistory");
        this.items = response.data;

        this.items.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        });
      } catch (error) {
        console.log(error);
      }
    },
    openFile(url) {
      window.open(url);
    },
  },
  async mounted() {
    await this.getFlashSalesHistory();
  },
  created() {
    this.getFlashSalesHistory();
  },
};
</script>
